import { Stack, Text } from "@mantine/core";

export const NoDataCreatedCard = ({
  dataLabel,
  ctaText,
}: {
  dataLabel: string;
  ctaText?: string;
}) => {
  return (
    <Stack gap={"var(--spacing-x-small)"} w={"100%"} ta={"center"} py={"var(--spacing-medium)"}>
      <Text
        ta={"center"}
        fw={"var(--font-weight-bold)"}
        fz={"var(--heading-font-size-h5)"}
        lh={"var(--heading-line-height-h5)"}
        c={"var(--text-strong)"}
      >
        No {dataLabel} Created Yet
      </Text>

      {ctaText && (
        <Text
          ta={"center"}
          fw={"var(--font-weight-regular)"}
          fz={"var(--text-font-size-medium)"}
          lh={"var(--text-line-height-medium)"}
          c={"var(--text-weak)"}
        >
          <Text
            component="span"
            style={{
              gap: "var(--spacing-3x-small)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Click the
            <Text
              component="span"
              style={{
                fontWeight: "var(--font-weight-medium)",
                color: "var(--text-default)",
                fontSize: "inherit",
                lineHeight: "inherit",
              }}
            >
              &quot;{ctaText}&quot;
            </Text>
            button to get started.{" "}
          </Text>
        </Text>
      )}
    </Stack>
  );
};
